import { render, staticRenderFns } from "./pda.vue?vue&type=template&id=35cafdb2&scoped=true"
import script from "./pda.vue?vue&type=script&setup=true&lang=ts"
export * from "./pda.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./pda.vue?vue&type=style&index=0&id=35cafdb2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cafdb2",
  null
  
)

export default component.exports